import { CartLineItem, cartLineItemChangeQuantityEvent, cartLineItemName, cartLineItemRemoveEvent, cartLineItemTagName, } from '@/components/ui';
import { cart } from '@/lib/cart';
import { Section, defineSection } from '@decify/cell-shopify/client';
import './cart-overview.scss';
// TODO: This has many duplicate settings of `cart-drawer.ts`. Extract common code to a shared component.
export const cartOverviewName = 'CartOverview';
export const cartOverviewTagName = 'cell-section-cart-overview';
export const cartOverviewUpdateEvent = 'update';
class CartOverview extends Section {
    domParser;
    constructor() {
        super(cartOverviewName);
        this.validateProps(['sectionId']);
        this.domParser = new DOMParser();
        this.handleItemChangeQuantity = this.handleItemChangeQuantity.bind(this);
        this.handleItemRemove = this.handleItemRemove.bind(this);
        this.render = this.render.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${cartLineItemName}.${cartLineItemChangeQuantityEvent}`, this.handleItemChangeQuantity);
        this.subscribe(`${cartLineItemName}.${cartLineItemRemoveEvent}`, this.handleItemRemove);
    }
    async handleItemChangeQuantity(data) {
        const cartChangeItemResponse = await cart.changeItem({
            id: data.key,
            quantity: data.quantity,
        });
        if (!cartChangeItemResponse.success) {
            const updatedCartLineItemElement = this.querySelector(`${cartLineItemTagName}[data-key="${data.key}"]`);
            if (!updatedCartLineItemElement || !(updatedCartLineItemElement instanceof CartLineItem)) {
                throw new Error('Updated cart line item not found');
            }
            updatedCartLineItemElement.resetQuantity();
            updatedCartLineItemElement.showError(cartChangeItemResponse.error);
            updatedCartLineItemElement.setLoading(false);
            return;
        }
        // TODO: Fix this type error.
        // @ts-ignore
        const html = cartChangeItemResponse.data.sections[this.props.sectionId];
        if (!html) {
            throw new Error('HTML not found');
        }
        this.render(this.domParser.parseFromString(html, 'text/html'));
        this.publish(cartOverviewUpdateEvent, {
            // TODO: Fix this type error.
            // @ts-ignore
            sections: cartChangeItemResponse.data.sections,
        });
    }
    async handleItemRemove(data) {
        const cartRemoveItemResponse = await cart.removeItem(data.key);
        if (!cartRemoveItemResponse.success) {
            // TODO: Handle error.
            return;
        }
        // TODO: Fix this type error.
        // @ts-ignore
        const html = cartRemoveItemResponse.data.sections[this.props.sectionId];
        if (!html) {
            throw new Error('HTML not found');
        }
        this.render(this.domParser.parseFromString(html, 'text/html'));
        this.publish(cartOverviewUpdateEvent, {
            // TODO: Fix this type error.
            // @ts-ignore
            sections: cartRemoveItemResponse.data.sections,
        });
    }
    render(doc) {
        this.querySelectorAll('[cell-update]').forEach((element) => {
            const newElement = doc.querySelector(`[cell-update="${element.getAttribute('cell-update')}"]`);
            if (newElement) {
                element.replaceWith(newElement);
            }
        });
    }
}
defineSection(cartOverviewTagName, CartOverview);
